// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hDiE5owcQEsBK95s {
  padding: 24px;
}
.IPc2WmPXse075_19 {
  margin-bottom: 16px;
  color: #666;
}
.k5jJ2QCpSYIbVYNN {
  padding: 0;
  font-size: 14px;
}
.R69Ja5sDa0lHwbro {
  display: inline-block;
  width: 1px;
  height: 16px;
  background: #d9d9d9;
  vertical-align: middle;
}
.wCxPhethEuF_xMBA .ant-modal-body {
  padding-top: 12px;
}
.GR4gf259gcUQ_Ghx {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
}
`, "",{"version":3,"sources":["webpack://./app/assets/pages/permissionManage/index.modules.less"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;AAEA;EACE,mBAAA;EACA,WAAA;AAAF;AAGA;EACE,UAAA;EACA,eAAA;AADF;AAIA;EACE,qBAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;AAFF;AAKA;EAEI,iBAAA;AAJJ;AAQA;EACE,oBAAA;EACA,qBAAA;EACA,aAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;AANF","sourcesContent":[".page {\n  padding: 24px;\n}\n\n.quota {\n  margin-bottom: 16px;\n  color: #666;\n}\n\n.backBtn {\n  padding: 0;\n  font-size: 14px;\n}\n\n.titleDivider {\n  display: inline-block;\n  width: 1px;\n  height: 16px;\n  background: #d9d9d9;\n  vertical-align: middle;\n}\n\n.logModal {\n  :global(.ant-modal-body) {\n    padding-top: 12px;\n  }\n}\n\n.logDetailCell {\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  word-break: break-all;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `hDiE5owcQEsBK95s`,
	"quota": `IPc2WmPXse075_19`,
	"backBtn": `k5jJ2QCpSYIbVYNN`,
	"titleDivider": `R69Ja5sDa0lHwbro`,
	"logModal": `wCxPhethEuF_xMBA`,
	"logDetailCell": `GR4gf259gcUQ_Ghx`
};
export default ___CSS_LOADER_EXPORT___;
